// extracted by mini-css-extract-plugin
module.exports = {"icon":"TooltipComponent_icon__3Bl_k"};